import React from "react";
import Navbar from "../connected/Navbar";
import Footer from "../connected/Footer";
import ResetPasswordHeroSection from "../sections/forgetPasswordSection/ResetPasswordHeroSection";
import PageHeader from "../primitive/PageHeader";

const ForgetPassword = () => {
  return (
    <div>
      <PageHeader browserTitle="Forgot Password | Smartcomply Seequre" />
      <Navbar />
      <ResetPasswordHeroSection />
      <Footer />
    </div>
  );
};

export default ForgetPassword;
